import React from "react";
import ExpenseItem from "./ExpenseItem";
import "./ExpensesList.css"

function ExpensesList(props) {

    // let expensesContent = <p>No Expenses Found</p>;

    if(props.expense.length === 0){
        return <>
         <h2 className="expenses-list__fallback">Oops!No Expenses Found. Please add a new expense!</h2>;
         
         </>
        
    }
    

    return(
        <ul className="expenses-list">
           
        {props.expense.map((expense) => (
            <ExpenseItem
                key={expense.id}
                title={expense.title}
                amount={expense.amount}
                date={expense.date}
            />
        ))}
    
        </ul>
    );

}
export default ExpensesList;